import iconDisponibilidad from "../../assets/disponibilidad inmediata.svg";
import iconUsado from "../../assets/tomamos tu usado.svg";

const CardBenefits = ({
  immediate = false,
  encargo = false,
  adjudicacion = false,
  showUsado = true,
}) => {
  if (!immediate && !encargo && !adjudicacion && !showUsado) return null;

  return (
    <div className="card-benefits">
      {immediate ? (
        <div className="card-benefits__item card-benefits__item--immediate">
          <img src={iconDisponibilidad} alt="" width="22" height="12" />
          <span>Disponibilidad inmediata</span>
        </div>
      ) : null}
      {encargo ? (
        <div className="card-benefits__item card-benefits__item--immediate">
          <img src={iconDisponibilidad} alt="" width="22" height="12" />
          <span>Entrega por encargo</span>
        </div>
      ) : null}
      {adjudicacion ? (
        <div className="card-benefits__item card-benefits__item--immediate">
          <img src={iconDisponibilidad} alt="" width="22" height="12" />
          <span>Adjudicación asegurada</span>
        </div>
      ) : null}
      {showUsado ? (
        <div className="card-benefits__item">
          <img src={iconUsado} alt="" width="20" height="17" />
          <span>Tomamos tu usado</span>
        </div>
      ) : null}
    </div>
  );
};

export default CardBenefits;
